"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./RemoveModalContent.scss");
var ui_components_1 = require("@idp/ui-components");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var utils_1 = require("@idp/ui-components/utils");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../../cms/Cart.cms");
var ReportingService_1 = require("../../../../api/ReportingService");
var cartStyles = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var RemoveModalContent = /** @class */ (function (_super) {
    __extends(RemoveModalContent, _super);
    function RemoveModalContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentLOB = _this.props.data.currentLOB;
        _this.isSonosinCart = _this.props.data.isSonosinCart;
        _this.isBundleinCart = _this.props.data.isBundleinCart;
        _this.displaySonosMsg = (_this.isSonosinCart && _this.currentLOB === 'DTVS');
        return _this;
    }
    RemoveModalContent.prototype.componentDidMount = function () {
        this.reportingService = new ReportingService_1.default();
    };
    RemoveModalContent.prototype.render = function () {
        var _this = this;
        this.cmsContent = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.removeModal;
        return (React.createElement("div", { className: styles.content },
            React.createElement("div", { id: "dialogTitle" },
                React.createElement(ui_components_1.Label, { testId: utils_1.default(this.currentLOB, 'Label', 'RemoveFromCart'), data: { text: this.cmsContent.removeModalTitle }, options: { className: cartStyles.rennyModalTitle } })),
            React.createElement("div", { className: styles.bodyDiv, id: "dialogDesc" },
                this.isBundleinCart &&
                    React.createElement("div", { className: styles.headsUpBody },
                        React.createElement("p", null,
                            this.cmsContent.bundleRemoveHeader,
                            ":"),
                        React.createElement("ul", { className: (this.currentLOB === 'BUSINESSAPPS' ||
                                this.currentLOB === 'BROADBAND') ? styles.bundleRemoveMsg : ' ' },
                            React.createElement("li", null,
                                " ",
                                this.cmsContent.bundleRemoveDiscountMsg,
                                " "),
                            React.createElement("li", null,
                                " ",
                                this.cmsContent.bundleRemovePromoMsg,
                                " "))),
                this.displaySonosMsg &&
                    this.isBundleinCart &&
                    React.createElement("div", { className: styles.headsUpDiv },
                        React.createElement("span", { className: styles.headsUp }, this.cmsContent.removeMessageHeaderLabel),
                        React.createElement("span", { className: styles.headsUpBody }, this.cmsContent.removeMessageBodyLabel)),
                React.createElement("div", { className: styles.bodyDiv },
                    React.createElement("span", { className: styles.bodyContent }, this.cmsContent.removeModalBody)),
                this.displaySonosMsg &&
                    !this.isBundleinCart &&
                    React.createElement("div", { className: styles.headsUpDiv },
                        React.createElement("span", { className: styles.headsUp }, this.cmsContent.removeMessageHeaderLabel),
                        React.createElement("span", { className: styles.headsUpBody }, this.cmsContent.removeMessageBodyLabel))),
            React.createElement("div", { className: styles.buttonsDiv },
                React.createElement("div", { className: styles.buttonClass },
                    React.createElement(ui_components_1.Button, { testId: utils_1.default(this.currentLOB, 'Button', 'Remove'), data: { text: this.cmsContent.removeButtonLabel }, events: { onClick: function () { _this.props.events.onRemoveClick(); } }, options: { className: cartStyles.rennyBtnr } })),
                React.createElement("div", { className: styles.buttonClass },
                    React.createElement(ui_components_1.Button, { testId: utils_1.default(this.currentLOB, 'Button', 'Cancel'), data: { text: this.cmsContent.cancelButtonLabel }, options: { type: ButtonProps_1.ButtonType.GHOST, className: cartStyles.rennyBtnr }, events: { onClick: function () {
                                _this.props.events.onCancelClick();
                            } } })))));
    };
    return RemoveModalContent;
}(React.Component));
exports.default = RemoveModalContent;
//# sourceMappingURL=RemoveModalContent.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/RemoveModalContent/RemoveModalContent.js
// module id = 2262
// module chunks = 8